var panel_element = document.querySelector('.js-map-menu');
var panel_element_overlay = document.querySelector('.js-map-menu-overlay'); // Used to overlay the header background as the map menu loads in the footer.

class MapMenuPanel {
    constructor() {
        this.body = document.body;
        this.site_header = document.querySelector('.voyager-header');
        this.main_menu = document.querySelector('.hamburger-button');
        this.open_btn = document.querySelectorAll('[data-type="map-menu"]');
        this.close_panel = panel_element.querySelectorAll('.js-close-panel');
        this.left_items = panel_element.querySelectorAll('.js-left-items li');
        this.right_items = panel_element.querySelectorAll('.js-right-items');
        this.map_element = panel_element.querySelector('.js-map-menu-main');
        this.map_data = JSON.parse(this.map_element.dataset.mapdata);
        this.map_data['container'] = this.map_element;
        this.map_data['zoom'] = 'auto';
        this.map_data['enableInfoWindow'] = true;
        this.handleLeftItem()
        this.items_key;
        this.mapInit();
        this.get_open_buttons();
        this.close_map_menu_panel();
    }

    get_open_buttons() {
        var _self = this;
        _self.open_btn.forEach(function (element) {
            _self.open_map_menu_panel(element);
        })
    }

    open_map_menu_panel(element) {
        var _self = this;
        element.addEventListener('click', function (e) {
            _self.toggle_panel_class()
            _self.toggle_button_class(e);
            _self.toggle_body_class();
        })
    }

    toggle_panel_class() {
        panel_element.removeAttribute('style');
        panel_element.classList.toggle('js-hidden');
        panel_element.classList.toggle('js-visible');

        panel_element_overlay.classList.toggle('js-hidden');
        panel_element_overlay.classList.toggle('js-visible');
    }

    toggle_button_class(element) {
        var _self = element.target;
        _self.classList.toggle('is-active');
    }

    toggle_body_class() {
        let body_class = document.body.classList.contains('js-map-menu-visible');
        if (body_class) {
            document.body.classList.remove('js-map-menu-visible');
            return;
        }
        document.body.classList.add('js-map-menu-visible');
    }

    close_map_menu_panel() {
        var _self = this;
        _self.close_panel.forEach(function (element) {
            element.addEventListener('click', function () {
                _self.toggle_panel_class();
                _self.open_btn.forEach(function (btn) {
                    _self.toggle_button_class({ target: btn });
                });
                _self.toggle_body_class();
            })
        })
    }

    handleLeftItem() {
        var _self = this;
        _self.left_items.forEach(function (item) {
            _self.handleLeftItemClick(item);
            _self.handleLeftItemHover(item);
        });
    }

    handleRightItem() {
        var _self = this;
        _self.right_items.forEach(function (item) {
            var item_key = item.dataset.itemsKey;
            if (item_key == _self.items_key) {
                _self.manageActiveClass(_self.right_items, item)
            }
        });
    }

    handleLeftItemHover(item) {
        var _self = this;
        item.addEventListener('mouseover', function () {
            _self.items_key = this.dataset.itemsKey;
            _self.manageActiveClass(_self.left_items, this);
            _self.handleRightItem();
            _self.map_helper.handleItemsSelection(this.dataset.id, 'infowindow');
        });
    }

    handleLeftItemClick(item) {
        var _self = this;
        item.addEventListener('click', function () {
            _self.items_key = this.dataset.itemsKey;
            _self.manageActiveClass(_self.left_items, this);
            _self.handleRightItem();
            _self.map_helper.handleItemsSelection(this.dataset.id, 'infowindow');
        });
    }

    manageActiveClass(ele, that = null) {
        ele.forEach(function (item) {
            item.classList.remove('is-active');
        });
        if (that == null) return;
        that.classList.add('is-active');
    }

    handleMarkerClick() {
        var _self = this;

        _self.map_helper.addMarkerClickListener((event) => {
            let marker_id = event.detail.id;
            panel_element.querySelector(`[data-id="${marker_id}"]`).click();
        });
    }

    mapInit() {
        var _self = this;
        _self.map_helper = new MapHelper(_self.map_data);
        _self.map_helper.initPlaceMarker(this.map_data['markers']);
        _self.handleMarkerClick();
    }
}

if (typeof (panel_element) != 'undefined' && panel_element != null) {
    var map_menu_panel = new MapMenuPanel();
}